import MayaMorning from "../Charts/JodiCharts/MayaMorning";
import INDRADAY from "../Charts/JodiCharts/INDRADAY";
import INDRAMORNING from "../Charts/JodiCharts/INDRAMORNING";
import INDRANIGHT from "../Charts/JodiCharts/INDRANIGHT";
import MAYADAY from "../Charts/JodiCharts/MAYADAY";
import MAYANIGHT from "../Charts/JodiCharts/MAYANIGHT";
import VEDADAY from "../Charts/JodiCharts/VEDADAY";
import VEDAMORNING from "../Charts/JodiCharts/VEDAMORNING";
import VEDANIGHT from "../Charts/JodiCharts/VEDANIGHT";
import DHARMMORNING from "../Charts/JodiCharts/DHARMMORNING";
import YUGDAY from "../Charts/JodiCharts/YUGDAY";
import YUGMORNING from "../Charts/JodiCharts/YUGMORNING";
import DHARMDAY from "../Charts/JodiCharts/DHARMDAY";
import DHARMNIGHT from "../Charts/JodiCharts/DHARMNIGHT";
import YUGNIGHT from "../Charts/JodiCharts/YUGNIGHT";
import RADHADAY from "../Charts/JodiCharts/RADHADAY";
import RADHAMORNING from "../Charts/JodiCharts/RADHAMORNING";
import RADHANIGHT from "../Charts/JodiCharts/RADHANIGHT";
import RAMADAY from "../Charts/JodiCharts/RAMADAY";
import RAMAMORNING from "../Charts/JodiCharts/RAMAMORNING";
import RAMANIGHT from "../Charts/JodiCharts/RAMANIGHT";
import SHRIDAY from "../Charts/JodiCharts/SHRIDAY";
import SHRIMORNING from "../Charts/JodiCharts/SHRIMORNING";
import SHRINIGHT from "../Charts/JodiCharts/SHRINIGHT";
import LAXMIMORNING from "../Charts/JodiCharts/LAXMIMORNING";
import LAXMINIGHT from "../Charts/JodiCharts/LAXMINIGHT";
import LAKSHMORNING from "../Charts/JodiCharts/LAKSHMORNING";
import LAKSHNIGHT from "../Charts/JodiCharts/LAKSHNIGHT";
import SANDHYAMORNING from "../Charts/JodiCharts/SANDHYAMORNING";


const normalize = (name) =>
  name?.replace(/\s+/g, "").toUpperCase();

export const JODI_CHART_COMPONENTS = {

  // Maya
  [normalize("MAYA MORNING")]: MayaMorning,
  [normalize("MAYADAY")]: MAYADAY,
  [normalize("MAYANIGHT")]: MAYANIGHT,

  // Indra
  [normalize("INDRADAY")]: INDRADAY,
  [normalize("INDRAMORNING")]: INDRAMORNING,
  [normalize("INDRANIGHT")]: INDRANIGHT,

  // Veda
  [normalize("VEDAMORNING")]: VEDAMORNING,
  [normalize("VEDADAY")]: VEDADAY,
  [normalize("VEDANIGHT")]: VEDANIGHT,

  // Yug
  [normalize("YUGMORNING")]: YUGMORNING,
  [normalize("YUGDAY")]: YUGDAY,
  [normalize("YUGNIGHT")]: YUGNIGHT,

  // Dharm
  [normalize("DHARMMORNING")]: DHARMMORNING,
  [normalize("DHARMDAY")]: DHARMDAY,
  [normalize("DHARMNIGHT")]: DHARMNIGHT,

  // Radha
  [normalize("RADHAMORNING")]: RADHAMORNING,
  [normalize("RADHADAY")]: RADHADAY,
  [normalize("RADHANIGHT")]: RADHANIGHT,

  // Shri
  [normalize("SHRIMORNING")]: SHRIMORNING,
  [normalize("SHRIDAY")]: SHRIDAY,
  [normalize("SHRINIGHT")]: SHRINIGHT,

  // Rama
  [normalize("RAMAMORNING")]: RAMAMORNING,
  [normalize("RAMADAY")]: RAMADAY,
  [normalize("RAMANIGHT")]: RAMANIGHT,

  // =========================
  // New Chart Aliases
  // =========================

  [normalize("VIDYAMORNING")]: MayaMorning,
  [normalize("GEETAMORNING")]: MAYADAY,
  [normalize("MORNING")]: MAYANIGHT,

  [normalize("SUMATIDAY")]: INDRANIGHT,
  [normalize("SUMATIMORNING")]: INDRAMORNING,
  [normalize("GEETADAY")]: INDRADAY,

  [normalize("INDUNIGHT")]: VEDAMORNING,
  [normalize("BHAGWATINIGHT")]: VEDADAY,
  [normalize("SATYANIGHT")]: VEDANIGHT,

  [normalize("VIDYADAY")]: YUGDAY,
  [normalize("VIDYANIGHT")]: YUGNIGHT,

  [normalize("GEETANIGHT")]: DHARMNIGHT,

  [normalize("LAXMIDAY")]: RADHADAY,
   [normalize("LAXMIMORNING")]: LAXMIMORNING,
   [normalize("LAXMINIGHT")]: LAXMINIGHT,
   [normalize("LAKSHMORNING")]: LAKSHMORNING,

  [normalize("SHRIDAY")]: RADHADAY,
  [normalize("RAMANIGHT")]: RADHADAY,
  [normalize("RAMADAY")]: RADHADAY,

  [normalize("LAKSHDAY")]: SHRIDAY,
  [normalize("LAKSHNIGHT")]: LAKSHNIGHT,

  [normalize("SANDHYADAY")]: RAMADAY,
  [normalize("SANDHYAMORNING")]: SANDHYAMORNING,

  [normalize("SUMATINIGHT")]: SHRINIGHT,

  [normalize("SANDHYANIGHT")]: RAMANIGHT,
};